import {
  defaultValue,
  ICandidateToResourceInstance,
} from "../shared/model/candidate-to-resource-instance.model";
import { REQUEST, FAILURE, SUCCESS } from "./actionType.util";
import axios from "axios";
import { jsonToFormData } from "../shared/helpers/mapEntityToFormDataPostulate";

export const ACTION_TYPES = {
  FETCH_RESOURCE_DETAIL: "resource/FETCH_RESOURCE_DETAIL",
  RESET: "resource/RESET",
  SEND_RESOURCE: "resource/SEND_RESOURCE",
};

const initialState = {
  loading: false,
  errorMessage: null,
  updating: false,
  updateSuccess: false,
  entity: defaultValue,
};

export type ResourceState = Readonly<typeof initialState>;

// REDUCER

export const resourceReducer = (
  state: ResourceState = initialState,
  action: any
) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_RESOURCE_DETAIL):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.SEND_RESOURCE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        responseSend: null,
        loading: true,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_RESOURCE_DETAIL):
    case FAILURE(ACTION_TYPES.SEND_RESOURCE):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        responseSend: null,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_RESOURCE_DETAIL):
      return {
        ...state,
        loading: false,
        updating: false,
        errorMessage: null,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.SEND_RESOURCE):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: true,
        errorMessage: null,
        entity: action.payload.data,
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

const apiUrl = "/api/ksds/portal-external/resource";

// ACTIONS
export const getEntity = (token: string) => {
  const requestUrl = `${apiUrl}/${token}`;
  return {
    type: ACTION_TYPES.FETCH_RESOURCE_DETAIL,
    payload: axios.get<ICandidateToResourceInstance>(requestUrl),
  };
};

export const sendForm: any =
  (entity: ICandidateToResourceInstance) => async (dispatch) => {
    const { formData, config } = jsonToFormData(entity);
    const requestUrl = `${apiUrl}/create`;
    const result = dispatch({
      type: ACTION_TYPES.SEND_RESOURCE,
      payload: axios.post(requestUrl, formData, config),
    });
    return result;
  };

export const reset = () => {
  return {
    type: ACTION_TYPES.RESET,
  };
};
